import { z } from 'zod';

export const shippingTariffSchema = z.enum(['Slow', 'Fast', 'Express']);

export type ShippingTariffSchema = z.infer<typeof shippingTariffSchema>;
